<template>
  <b-modal ref="technicalDevice-card-modal" @ok="technicalDeviceCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.technicalDevices.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns.nameTechnicalDevice"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="nameTechnicalDevice"
          :state="isNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns.registerNumber"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="registerNumber"
          :state="isRegisterNumberValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns.brand"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="brand"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns.typeVehicle"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="typeId"
          :state="isTypeValid"
          :options="typeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns.volumeFuelTank"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="1000"
          v-model="volumeFuelTank"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.created"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="created"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.updated"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="updated"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="technicalDevice.executor"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { utilsService, azkService } from "../../../../services";

export default {
  name: "UpdateTechnicalDevicePage",
  props: {
    technicalDevice: Object,
  },
  components: {},
  data() {
    return {
      nameTechnicalDevice: null,
      registerNumber: null,
      brand: null,
      typeId: null,
      volumeFuelTank: null,

      isNameValid: null,
      isRegisterNumberValid: null,
      isTypeValid: null,
      created: null,
      updated: null
    };
  },
  computed: {
    typeOptions() {
      const typeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.azk.technicalDevices.typeOptions
          .length;
        i++
      ) {
        typeOptions.push({
          value:
            this.$store.state.localization.data.mainPage.azk.technicalDevices
              .typeOptions[i].key,
          text: this.$store.state.localization.data.mainPage.azk.technicalDevices
            .typeOptions[i].value,
        });
      }
      return typeOptions;
    },
  },
  methods: {
    async open() {
      this.nameTechnicalDevice = this.technicalDevice.nameTechnicalDevice;
      this.registerNumber = this.technicalDevice.registerNumber;
      this.brand = this.technicalDevice.brand;
      this.typeId = this.technicalDevice.typeVehicle;
      this.volumeFuelTank = this.technicalDevice.volumeFuelTank;

      this.isNameValid = null;
      this.isRegisterNumberValid = null;
      this.isTypeValid = null;

      this.created = utilsService.formatDateTime(new Date(this.technicalDevice.created * 1000), utilsService.DATE_TIME_FORMAT);
      this.updated = utilsService.formatDateTime(new Date(this.technicalDevice.updated * 1000), utilsService.DATE_TIME_FORMAT);

      this.$refs["technicalDevice-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.nameTechnicalDevice) {
        this.isNameValid = false;
        isValid = false;
      } else {
        this.isNameValid = null;
      }

      if (!this.registerNumber) {
        this.isRegisterNumberValid = false;
        isValid = false;
      } else {
        this.isRegisterNumberValid = null;
      }

      if (!this.typeId) {
        this.isTypeValid = false;
        isValid = false;
      } else {
        this.isTypeValid = null;
      }

      return isValid;
    },
    async technicalDeviceCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      this.technicalDevice.nameTechnicalDevice = this.nameTechnicalDevice;
      this.technicalDevice.registerNumber = this.registerNumber;
      this.technicalDevice.brand = this.brand;
      this.technicalDevice.typeVehicle = parseInt(this.typeId);
      this.technicalDevice.volumeFuelTank = parseFloat(this.volumeFuelTank);
      
      const updateTechnicalDeviceResponse = await azkService.updateTechnicalDevice(this.technicalDevice);

      if (
        updateTechnicalDeviceResponse.isSuccess &&
        updateTechnicalDeviceResponse.data &&
        updateTechnicalDeviceResponse.data.countInsertedRows == 1
      ) {
        this.$emit("technicalDeviceUpdatedSuccessEvent", this.technicalDevice);
      } else {
        this.$emit("technicalDeviceUpdatedFailEvent");
      }
    },
  },
};
</script>
